import { AxiosInstance } from 'axios';
import MockAdapter from 'axios-mock-adapter';
import { ListedInstrument } from '../types';
import { withDelayResolved } from '../utils/mockUtils';

const mockInstrumentSearch: ListedInstrument[] = [
  {
    ticker: 'OTP',
    ric: 'OTPB.BU',
    currency: 'HUF',
    allowToNYESZ: true,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'OTP',
    isin: 'HU0000061726',
    instrumentCategory: 'EQ',
    canBeShorted: true,
    collateralValue: 0.0,
    mic: 'XBU2',
    marketName: 'XETRA - BÉT',
    marketShortName: 'BÉT',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'MTELEKOM',
    ric: 'MTEL.BU',
    currency: 'HUF',
    allowToNYESZ: true,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'MAGYAR TELEKOM',
    isin: 'HU0000073507',
    instrumentCategory: 'EQ',
    canBeShorted: true,
    collateralValue: 0.0,
    mic: 'XBU2',
    marketName: 'XETRA - BÉT',
    marketShortName: 'BÉT',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'AAPL',
    ric: 'AAPL.NB',
    currency: 'USD',
    allowToNYESZ: false,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'Apple Inc.',
    isin: 'US0378331005',
    instrumentCategory: 'EQ',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XNAS',
    marketName: 'NASDAQ - ALL MARKETS (O)',
    marketShortName: 'NASDAQ',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'BMW',
    ric: 'BMWG.F',
    currency: 'EUR',
    mainMarketMICCode: 'XETR',
    mainMarketRIC: 'BMWG.DE',
    allowToNYESZ: false,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'BMW',
    isin: 'DE0005190003',
    instrumentCategory: 'EQ',
    canBeShorted: true,
    collateralValue: 0.0,
    mic: 'XFRA',
    marketName: 'FRANKFURT STOCK EXCHANGE',
    marketShortName: 'XETRA 2',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'SXR8',
    ric: 'SXR8.DE',
    currency: 'EUR',
    allowToNYESZ: false,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'iShares Core S&P 500 UCITS ETF USD',
    isin: 'IE00B5BMR087',
    instrumentCategory: 'ETF',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XETR',
    marketName: 'XETRA -FRANKFURT',
    marketShortName: 'Frankfurt',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'EUNL',
    ric: 'EUNL.DE',
    currency: 'EUR',
    allowToNYESZ: false,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'ISHARES CORE MSCI WORLD UCITS ETF',
    isin: 'IE00B4L5Y983',
    instrumentCategory: 'ETF',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XETR',
    marketName: 'XETRA -FRANKFURT',
    marketShortName: 'Frankfurt',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'IS3N',
    ric: 'IS3N.DE',
    currency: 'EUR',
    allowToNYESZ: false,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'iShares Core MSCI EM IMI UCITS ETF USD (Acc)',
    isin: 'IE00BKM4GZ66',
    instrumentCategory: 'ETF',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XETR',
    marketName: 'XETRA -FRANKFURT',
    marketShortName: 'Frankfurt',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'ISF',
    ric: 'ISF.DE',
    currency: 'EUR',
    allowToNYESZ: false,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'ISHARES FTSE 1000',
    isin: 'IE0005042456',
    instrumentCategory: 'ETF',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XETR',
    marketName: 'XETRA -FRANKFURT',
    marketShortName: 'Frankfurt',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'SXRV',
    ric: 'SXRV.DE',
    currency: 'EUR',
    allowToNYESZ: false,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'iShares NASDAQ 100 UCITS ETF USD (Acc)',
    isin: 'IE00B53SZB19',
    instrumentCategory: 'ETF',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XETR',
    marketName: 'XETRA -FRANKFURT',
    marketShortName: 'Frankfurt',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'VWCE',
    ric: 'VWCE.DE',
    currency: 'EUR',
    allowToNYESZ: false,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'Vanguard FTSE All-World UCITS ETF USD Acc',
    isin: 'IE00BK5BQT80',
    instrumentCategory: 'ETF',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XETR',
    marketName: 'XETRA -FRANKFURT',
    marketShortName: 'Frankfurt',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'EXW1',
    ric: 'STX50EEX.DE',
    currency: 'EUR',
    allowToNYESZ: false,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'EUROSTOXX',
    isin: 'DE0005933956',
    instrumentCategory: 'ETF',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XETR',
    marketName: 'XETRA -FRANKFURT',
    marketShortName: 'Frankfurt',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'EXS1',
    ric: 'GDAXIEX.DE',
    currency: 'EUR',
    allowToNYESZ: false,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'DAXEX',
    isin: 'DE0005933931',
    instrumentCategory: 'ETF',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XETR',
    marketName: 'XETRA -FRANKFURT',
    marketShortName: 'Frankfurt',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'RICHTER',
    ric: 'GDRB.BU',
    currency: 'HUF',
    allowToNYESZ: true,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'RICHTER',
    isin: 'HU0000123096',
    instrumentCategory: 'EQ',
    canBeShorted: true,
    collateralValue: 0.0,
    mic: 'XBU2',
    marketName: 'XETRA - BÉT',
    marketShortName: 'BÉT',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: '4IG',
    ric: 'IGNY.BU',
    currency: 'HUF',
    allowToNYESZ: true,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: '4IG',
    isin: 'HU0000167788',
    instrumentCategory: 'EQ',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XBU2',
    marketName: 'XETRA - BÉT',
    marketShortName: 'BÉT',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'OPUS',
    ric: 'OPUSG.BU',
    currency: 'HUF',
    allowToNYESZ: true,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'OPUS',
    isin: 'HU0000110226',
    instrumentCategory: 'EQ',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XBU2',
    marketName: 'XETRA - BÉT',
    marketShortName: 'BÉT',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'PANNERGY',
    ric: 'PANP.BU',
    currency: 'HUF',
    allowToNYESZ: true,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'PANNERGY',
    isin: 'HU0000089867',
    instrumentCategory: 'EQ',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XBU2',
    marketName: 'XETRA - BÉT',
    marketShortName: 'BÉT',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'WABERERS',
    ric: 'WABE.BU',
    currency: 'HUF',
    allowToNYESZ: true,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'WABERERS',
    isin: 'HU0000120720',
    instrumentCategory: 'EQ',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XBU2',
    marketName: 'XETRA - BÉT',
    marketShortName: 'BÉT',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'MASTERPLAST',
    ric: 'MAST.BU',
    currency: 'HUF',
    allowToNYESZ: true,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'MASTERPLAST',
    isin: 'HU0000093943',
    instrumentCategory: 'EQ',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XBU2',
    marketName: 'XETRA - BÉT',
    marketShortName: 'BÉT',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'AUTOWALLIS',
    ric: 'AUTW.BU',
    currency: 'HUF',
    allowToNYESZ: true,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'AUTOWALLIS',
    isin: 'HU0000164504',
    instrumentCategory: 'EQ',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XBU2',
    marketName: 'XETRA - BÉT',
    marketShortName: 'BÉT',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'OTP',
    ric: 'OTPB.F',
    currency: 'EUR',
    mainMarketMICCode: 'XBU2',
    mainMarketRIC: 'OTPB.BU',
    allowToNYESZ: false,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'OTP',
    isin: 'HU0000061726',
    instrumentCategory: 'EQ',
    canBeShorted: true,
    collateralValue: 0.0,
    mic: 'XFRA',
    marketName: 'FRANKFURT STOCK EXCHANGE',
    marketShortName: 'XETRA 2',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'EBOTPTL08',
    ric: 'AT00A0RNQ3.BU',
    currency: 'HUF',
    allowToNYESZ: true,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'ERSTE OTP TURBO LONG 08',
    isin: 'AT0000A0RNQ3',
    instrumentCategory: 'CRT',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XBU2',
    marketName: 'XETRA - BÉT',
    marketShortName: 'BÉT',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'EBMOLTL15',
    ric: 'AT00A194E5.BU',
    currency: 'HUF',
    allowToNYESZ: true,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'ERSTE MOL TURBO LONG 15',
    isin: 'AT0000A194E5',
    instrumentCategory: 'CRT',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XBU2',
    marketName: 'XETRA - BÉT',
    marketShortName: 'BÉT',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'EBBUXTL42',
    ric: 'AT00A2K9Y1.BU',
    currency: 'HUF',
    allowToNYESZ: true,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'Erste BUX Turbo Long 42',
    isin: 'AT0000A2K9Y1',
    instrumentCategory: 'CRT',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XBU2',
    marketName: 'XETRA - BÉT',
    marketShortName: 'BÉT',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'MOL',
    ric: 'MOLB.BU',
    currency: 'HUF',
    allowToNYESZ: true,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'MOL',
    isin: 'HU0000153937',
    instrumentCategory: 'EQ',
    canBeShorted: true,
    collateralValue: 0.0,
    mic: 'XBU2',
    marketName: 'XETRA - BÉT',
    marketShortName: 'BÉT',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'DBK',
    ric: 'DBKGn.F',
    currency: 'EUR',
    mainMarketMICCode: 'XETR',
    mainMarketRIC: 'DBKGn.DE',
    allowToNYESZ: false,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'DEUTSCHE BANK',
    isin: 'DE0005140008',
    instrumentCategory: 'EQ',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XFRA',
    marketName: 'FRANKFURT STOCK EXCHANGE',
    marketShortName: 'XETRA 2',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'WMT',
    ric: 'WMT.NB',
    currency: 'USD',
    allowToNYESZ: false,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'Wal-Mart Stores Inc.',
    isin: 'US9311421039',
    instrumentCategory: 'EQ',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XNYS',
    marketName: 'NEW YORK STOCK EXCHANGE',
    marketShortName: 'NYSE',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
  {
    ticker: 'META',
    ric: 'META.NB',
    currency: 'USD',
    allowToNYESZ: false,
    tradeable: true,
    lastClosePrice: 0.0,
    instrumentName: 'Meta Platforms Inc.',
    isin: 'US30303M1027',
    instrumentCategory: 'EQ',
    canBeShorted: false,
    collateralValue: 0.0,
    mic: 'XNAS',
    marketName: 'NASDAQ - ALL MARKETS (O)',
    marketShortName: 'NASDAQ',
    reutersRegionCode: null,
    bestExecution: false,
    defaultMarket: false,
    tradableInApp: true,
  },
];

export const initMockedInstrumentResource = (axiosInstance: AxiosInstance) => {
  var mock = new MockAdapter(axiosInstance, { onNoMatch: 'passthrough', delayResponse: 100 });

  mock
    .onGet(new RegExp('https://wso2test.ebihnettest.ersteinv.hu:9443/instrumentService/v1'))
    .reply(withDelayResolved(Math.trunc(Math.random() * 1000), [200, mockInstrumentSearch]));
};
